var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.833984H2.5C1.83696 0.833984 1.20107 1.09738 0.732233 1.56622C0.263392 2.03506 0 2.67094 0 3.33398L0 19.1673H20V3.33398C20 2.67094 19.7366 2.03506 19.2678 1.56622C18.7989 1.09738 18.163 0.833984 17.5 0.833984ZM2.5 2.50065H17.5C17.721 2.50065 17.933 2.58845 18.0893 2.74473C18.2455 2.90101 18.3333 3.11297 18.3333 3.33398V3.88982L11.7683 10.4556C11.2987 10.9234 10.6628 11.186 10 11.186C9.33715 11.186 8.70131 10.9234 8.23167 10.4556L1.66667 3.88982V3.33398C1.66667 3.11297 1.75446 2.90101 1.91074 2.74473C2.06702 2.58845 2.27899 2.50065 2.5 2.50065ZM1.66667 17.5006V6.25065L7.05333 11.634C7.83552 12.4142 8.89521 12.8523 10 12.8523C11.1048 12.8523 12.1645 12.4142 12.9467 11.634L18.3333 6.25065V17.5006H1.66667Z",
    fill: "#26ABB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.733ef1a8392cdec6e0580bee77702a63.svg";
export { ForwardRef as ReactComponent };